/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import '@lit-labs/ssr-dom-shim/register-css-hook.js';
import {installWindowOnGlobal} from './dom-shim.js';
installWindowOnGlobal();
